export class BaseClass {
    id: number;
    description: string;

    constructor(id: number, description: string) {
        this.id = id;
        this.description = description
    }
}

export const years = [
    new BaseClass(2020, '2020'),
    new BaseClass(2021, '2021'),
    new BaseClass(2022, '2022'),
    new BaseClass(2023, '2023'),
    new BaseClass(2024, '2024'),
    new BaseClass(2025, '2025'),
]
